"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TertiaryBlockSize = exports.SecondaryBlockSize = void 0;
/**
 * Variant size of a block determines which Secondary and Tertiary blocks, can "fit" within a Primary block
 * with a defined block variant size.
 *
 */
var SecondaryBlockSize;
(function (SecondaryBlockSize) {
    SecondaryBlockSize["ExtraSmall"] = "ExtraSmall";
    SecondaryBlockSize["Small"] = "Small";
    SecondaryBlockSize["Medium"] = "Medium";
    SecondaryBlockSize["Large"] = "Large";
    SecondaryBlockSize["None"] = "None";
})(SecondaryBlockSize = exports.SecondaryBlockSize || (exports.SecondaryBlockSize = {}));
var TertiaryBlockSize;
(function (TertiaryBlockSize) {
    TertiaryBlockSize["Default"] = "Default";
    TertiaryBlockSize["None"] = "None";
})(TertiaryBlockSize = exports.TertiaryBlockSize || (exports.TertiaryBlockSize = {}));
